import NextLink from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

import Button from 'shopper/components/Button';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';
import { getFirstPathFromPathname } from 'lib/request';

import LINKS from 'constants/links';

const METADATA_BY_SITE_VERTICAL_BASE_PATH = {
  [LINKS.COUPONS]: {
    gaEventAction: 'topbar_suggest_coupon',
    url: LINKS.NEW_COUPON,
    text: placeholder('actions.suggestCoupon'),
  },
  [LINKS.FORUM]: {
    gaEventAction: 'topbar_suggest_thread',
    url: LINKS.NEW_THREAD,
    text: placeholder('actions.suggestThreadShort'),
  },
  default: {
    gaEventAction: 'topbar_suggest_offer',
    url: LINKS.NEW_OFFER,
    text: placeholder('actions.suggestOffer'),
  },
};

const SuggestionButton = ({ gaEventCategory }) => {
  const router = useRouter();

  const verticalBasePath = getFirstPathFromPathname(router.pathname);

  const metadata = useMemo(
    () =>
      METADATA_BY_SITE_VERTICAL_BASE_PATH[verticalBasePath] ??
      METADATA_BY_SITE_VERTICAL_BASE_PATH.default,
    [verticalBasePath]
  );

  return (
    <NextLink href={metadata.url} prefetch={false} passHref>
      <Button
        as="a"
        className="w-[177px]"
        size="size3"
        onClick={() => {
          sendEvent({
            action: metadata.gaEventAction,
            category: gaEventCategory,
          });
        }}
      >
        {metadata.text}
      </Button>
    </NextLink>
  );
};

SuggestionButton.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default SuggestionButton;
